/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function Google({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
<path d="M13.9778 8.13885C13.9778 7.70552 13.9389 7.28885 13.8667 6.88885H8.11108V9.25552H11.4C11.2555 10.0166 10.8222 10.6611 10.1722 11.0944V12.6333H12.1555C13.3111 11.5666 13.9778 9.99997 13.9778 8.13885Z" fill="#4285F4"></path>
<path d="M8.11107 14.1111C9.76108 14.1111 11.1444 13.5666 12.1555 12.6333L10.1722 11.0944C9.62778 11.4611 8.93329 11.6833 8.11107 11.6833C6.52218 11.6833 5.17218 10.6111 4.68885 9.16663H2.65551V10.7444C3.66107 12.7388 5.72218 14.1111 8.11107 14.1111Z" fill="#34A853"></path>
<path d="M4.68888 9.16111C4.56666 8.79444 4.49444 8.40555 4.49444 8C4.49444 7.59444 4.56666 7.20555 4.68888 6.83889V5.26111H2.65555C2.23888 6.08333 2 7.01111 2 8C2 8.98889 2.23888 9.91666 2.65555 10.7389L4.23888 9.50555L4.68888 9.16111Z" fill="#FBBC05"></path>
<path d="M8.11107 4.32219C9.01107 4.32219 9.81108 4.6333 10.45 5.2333L12.2 3.4833C11.1389 2.49441 9.76108 1.88885 8.11107 1.88885C5.72218 1.88885 3.66107 3.26108 2.65551 5.26108L4.68885 6.83885C5.17218 5.39441 6.52218 4.32219 8.11107 4.32219Z" fill="#EA4335"></path>

    </svg>
  );
}
